"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = exports.CollectionTradeTrendFilterDays = exports.AssetSortBy = exports.AbiType = exports.OfferType = exports.StateMutability = exports.FunctionOutputKind = exports.FunctionInputKind = exports.HowToCall = exports.SaleKind = exports.OrderType = exports.OrderSide = exports.FeeMethod = exports.TokenStandardVersion = exports.APENFTSchemaName = exports.MakeOrderType = exports.Network = exports.TronWeb = void 0;
var tronweb_1 = __importDefault(require("tronweb"));
exports.TronWeb = tronweb_1.default;
var Network;
(function (Network) {
    Network["Tron"] = "tron";
    Network["Shasta"] = "shasta";
})(Network = exports.Network || (exports.Network = {}));
var MakeOrderType;
(function (MakeOrderType) {
    MakeOrderType["FixPriceOrder"] = "FixPriceOrder";
    MakeOrderType["DutchAuctionOrder"] = "DutchAuctionOrder";
    MakeOrderType["EnglishAuctionOrder"] = "EnglishAuctionOrder";
    MakeOrderType["LowerPriceOrder"] = "LowerPriceOrder";
    MakeOrderType["MakeOfferOrder"] = "MakeOfferOrder";
    MakeOrderType["EnglishAuctionBiddingOrder"] = "EnglishAuctionBiddingOrder";
})(MakeOrderType = exports.MakeOrderType || (exports.MakeOrderType = {}));
var APENFTSchemaName;
(function (APENFTSchemaName) {
    APENFTSchemaName["ERC20"] = "ERC20";
    APENFTSchemaName["ERC721"] = "ERC721";
    APENFTSchemaName["ERC1155"] = "ERC1155";
})(APENFTSchemaName = exports.APENFTSchemaName || (exports.APENFTSchemaName = {}));
var TokenStandardVersion;
(function (TokenStandardVersion) {
    TokenStandardVersion["Unsupported"] = "unsupported";
    TokenStandardVersion["Locked"] = "locked";
    TokenStandardVersion["Enjin"] = "1155-1.0";
    TokenStandardVersion["ERC721v1"] = "1.0";
    TokenStandardVersion["ERC721v2"] = "2.0";
    TokenStandardVersion["ERC721v3"] = "3.0";
})(TokenStandardVersion = exports.TokenStandardVersion || (exports.TokenStandardVersion = {}));
var FeeMethod;
(function (FeeMethod) {
    FeeMethod[FeeMethod["ProtocolFee"] = 0] = "ProtocolFee";
    FeeMethod[FeeMethod["SplitFee"] = 1] = "SplitFee";
})(FeeMethod = exports.FeeMethod || (exports.FeeMethod = {}));
var OrderSide;
(function (OrderSide) {
    OrderSide[OrderSide["Buy"] = 0] = "Buy";
    OrderSide[OrderSide["Sell"] = 1] = "Sell";
})(OrderSide = exports.OrderSide || (exports.OrderSide = {}));
var OrderType;
(function (OrderType) {
    OrderType[OrderType["All"] = -1] = "All";
    OrderType[OrderType["Buy"] = 0] = "Buy";
    OrderType[OrderType["Sell"] = 1] = "Sell";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var SaleKind;
(function (SaleKind) {
    SaleKind[SaleKind["FixedPrice"] = 0] = "FixedPrice";
    SaleKind[SaleKind["DutchAuction"] = 1] = "DutchAuction";
})(SaleKind = exports.SaleKind || (exports.SaleKind = {}));
var HowToCall;
(function (HowToCall) {
    HowToCall[HowToCall["Call"] = 0] = "Call";
    HowToCall[HowToCall["DelegateCall"] = 1] = "DelegateCall";
    HowToCall[HowToCall["StaticCall"] = 2] = "StaticCall";
    HowToCall[HowToCall["Create"] = 3] = "Create";
})(HowToCall = exports.HowToCall || (exports.HowToCall = {}));
var FunctionInputKind;
(function (FunctionInputKind) {
    FunctionInputKind["Replaceable"] = "replaceable";
    FunctionInputKind["Asset"] = "asset";
    FunctionInputKind["Owner"] = "owner";
    FunctionInputKind["Index"] = "index";
    FunctionInputKind["Count"] = "count";
    FunctionInputKind["Data"] = "data";
})(FunctionInputKind = exports.FunctionInputKind || (exports.FunctionInputKind = {}));
var FunctionOutputKind;
(function (FunctionOutputKind) {
    FunctionOutputKind["Owner"] = "owner";
    FunctionOutputKind["Asset"] = "asset";
    FunctionOutputKind["Count"] = "count";
    FunctionOutputKind["Other"] = "other";
})(FunctionOutputKind = exports.FunctionOutputKind || (exports.FunctionOutputKind = {}));
var StateMutability;
(function (StateMutability) {
    StateMutability["Pure"] = "pure";
    StateMutability["View"] = "view";
    StateMutability["Payable"] = "payable";
    StateMutability["Nonpayable"] = "nonpayable";
})(StateMutability = exports.StateMutability || (exports.StateMutability = {}));
var OfferType;
(function (OfferType) {
    OfferType["Default"] = "default";
    OfferType["ContractOffer"] = "contract_offer";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var AbiType;
(function (AbiType) {
    AbiType["Function"] = "function";
    AbiType["Constructor"] = "constructor";
    AbiType["Event"] = "event";
    AbiType["Fallback"] = "fallback";
})(AbiType = exports.AbiType || (exports.AbiType = {}));
var AssetSortBy;
(function (AssetSortBy) {
    AssetSortBy["HighestLastSale"] = "HighestLastSale";
    AssetSortBy["RecentlyListed"] = "RecentlyListed";
    AssetSortBy["PriceLowToHigh"] = "PriceLowToHigh";
    AssetSortBy["PriceHighToLow"] = "PriceHighToLow";
    AssetSortBy["RecentlyTransfer"] = "RecentlyTransfer";
    AssetSortBy["RecentlyCreated"] = "RecentlyCreated";
    AssetSortBy["RecentlySold"] = "RecentlySold";
    AssetSortBy["EndingSoon"] = "EndingSoon";
})(AssetSortBy = exports.AssetSortBy || (exports.AssetSortBy = {}));
var CollectionTradeTrendFilterDays;
(function (CollectionTradeTrendFilterDays) {
    CollectionTradeTrendFilterDays["Days_7"] = "Days_7";
    CollectionTradeTrendFilterDays["Days_14"] = "Days_14";
    CollectionTradeTrendFilterDays["Days_30"] = "Days_30";
    CollectionTradeTrendFilterDays["Days_60"] = "Days_60";
    CollectionTradeTrendFilterDays["Days_90"] = "Days_90";
    CollectionTradeTrendFilterDays["Days_365"] = "Days_365";
    CollectionTradeTrendFilterDays["Days_All"] = "Days_All";
})(CollectionTradeTrendFilterDays = exports.CollectionTradeTrendFilterDays || (exports.CollectionTradeTrendFilterDays = {}));
var EventType;
(function (EventType) {
    EventType["Transfer"] = "Transfer";
    EventType["Offer"] = "Offer";
    EventType["Listing"] = "Listing";
    EventType["CancelOffer"] = "CancelOffer";
    EventType["CancelListing"] = "CancelListing";
    EventType["Mint"] = "Mint";
    EventType["Burn"] = "Burn";
    EventType["Sale"] = "Sale";
})(EventType = exports.EventType || (exports.EventType = {}));
